import { useMemo } from 'react';
import { transformPortfoliosToKeys, useGetUserPortfolios } from './portfolios/useGetUserPortfolios';
import { PortfolioTypes } from '~/models/PortfolioType';

// TODO: add the errors and stuff to the return object too
export const useGetUserPortfoliosInfo = () => {
    const { data: userPortfolios, isSuccess } = useGetUserPortfolios();

    const portfolios = useMemo(() => {
        return userPortfolios?.portfolios ? transformPortfoliosToKeys(userPortfolios.portfolios) : undefined;
    }, [userPortfolios]);

    const userId = portfolios?.managed?.userID;
    return useMemo(
        () => ({
            whiskey: portfolios?.managed,
            wine: portfolios?.managed,
            managed: portfolios?.managed,
            trading: {
                id: userId ? `tp_${userId}` : undefined,
                type: PortfolioTypes.trading,
                userID: userId
            },
            userPortfolios,
            isWhiskeySuccess: isSuccess,
            isManagedSucces: isSuccess,
            isWineSucces: isSuccess
        }),
        [portfolios, userPortfolios, isSuccess]
    );
};
